export { StyledComponentsRegistry } from './StyledComponentRegistry';
